import { Util } from "/global/js/util.min.js?v=1749578964";
const util = new Util();
util.bootstrapWasValidated();
util.addAsteriskRequiredFieldsLabel();
const wrapper = document.querySelector(".is-wrapper");
const navigationTop = document.querySelector("nav.top");
const footerHeight = document.querySelector("footer");
function calculateWrapper() {
  const windowHeight = window.innerHeight;
  const minHeight = windowHeight - navigationTop.offsetHeight - footerHeight.offsetHeight;
  wrapper.style.minHeight = minHeight + 'px';
}
function adjustScrollPaddingTop() {
  const navigationPosition = getComputedStyle(navigationTop).position;
  if (navigationPosition !== "fixed") {
    return;
  }

  //document.documentElement er html elementet
  document.documentElement.style.scrollPaddingTop = navigationTop.offsetHeight + 'px';
}
if (wrapper && navigationTop) {
  calculateWrapper();
  window.addEventListener('resize', () => calculateWrapper());
}
if (navigationTop) {
  adjustScrollPaddingTop();
  window.addEventListener('resize', () => adjustScrollPaddingTop());
}
document.querySelectorAll('a[target="_blank"]').forEach(link => {
  const linkText = link.textContent.trim();
  if (!link.hasAttribute('aria-label')) {
    link.setAttribute('aria-label', linkText + ' (åbner i nyt vindue/fane)');
  }
  const fields = document.querySelectorAll('input[required], textarea[required], select[required]');
  fields.forEach(field => field.setAttribute('aria-required', 'true'));
});

// Nedenstående script sørger for at skip-to-content kunne kommer frem ved egentlig tab
const skip = document.querySelector('#skip-to-content');
let usingKeyboard = false;
window.addEventListener('keydown', e => {
  if (e.key === 'Tab') usingKeyboard = true;
});
window.addEventListener('mousedown', () => {
  usingKeyboard = false;
});
skip.addEventListener('focus', () => {
  if (usingKeyboard) {
    // Kun ved “ægte” tab-fokus: gør det synligt
    skip.classList.add('visible-skip');
  } else {
    // Programmatisk fokus (fx DevTools): fjern fokus med det samme
    skip.blur();
  }
});
skip.addEventListener('blur', () => {
  skip.classList.remove('visible-skip');
});
window.addEventListener('focus', () => {
  if (document.activeElement === skip && !usingKeyboard) {
    skip.blur();
  }
});